var map = {
	"./common/article-mv": [
		2817,
		516
	],
	"./common/article-mv.ts": [
		2817,
		516
	],
	"./common/article-pc": [
		9891,
		1698
	],
	"./common/article-pc.ts": [
		9891,
		1698
	],
	"./news/directory-mv": [
		72,
		423
	],
	"./news/directory-mv.ts": [
		72,
		423
	],
	"./news/directory-pc": [
		8294,
		9025
	],
	"./news/directory-pc.ts": [
		8294,
		9025
	],
	"./news/home-mv": [
		4828,
		7459
	],
	"./news/home-mv.ts": [
		4828,
		7459
	],
	"./news/home-pc": [
		493,
		9581
	],
	"./news/home-pc.ts": [
		493,
		9581
	],
	"./news/locality-mv": [
		130,
		1405
	],
	"./news/locality-mv.ts": [
		130,
		1405
	],
	"./news/locality-pc": [
		3848,
		8031
	],
	"./news/locality-pc.ts": [
		3848,
		8031
	],
	"./ram/directory-mv": [
		1761,
		7684
	],
	"./ram/directory-mv.ts": [
		1761,
		7684
	],
	"./ram/directory-pc": [
		131,
		1922
	],
	"./ram/directory-pc.ts": [
		131,
		1922
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8814;
module.exports = webpackAsyncContext;